import { getState, patchState, signalStoreFeature, withHooks, withMethods, withState } from '@ngrx/signals';
import { updateState } from '@angular-architects/ngrx-toolkit';

/**

 /**
 * Creates a custom store feature that adds reset functionality to a signal store.
 *
 * This feature adds:
 * A `reset` method to restore the store to its initial state
 *
 * @returns A signal store feature with reset capability
 */
export function withReset(name = 'unknown') {
  return signalStoreFeature(
    withState({
      _resetState: {},
    }),
    withMethods((store) => ({
      resetState: () => {
        updateState(store, `${name} - reset state`, store._resetState);
      },
    })),
    withHooks((store) => ({
      onInit() {
        // Get current state and exclude our internal _resetState
        const currentState = getState(store);
        const { _resetState, ...initialState } = currentState;
        patchState(store, { _resetState: initialState });
      },
    })),
  );
}
